import * as BusinessBL from './business-bl'
import * as UserDAL from '../dal/user-dal'
import { isObjectEmpty } from "../utils.js";

import {
    userDetails
} from "../stores.js";

let unsubscribeUserDetails;

export async function listenToUserDetails(authUser) {
    if (!authUser) return Promise.reject("not logged in");

    try {
        unsubscribeUserDetails =
            UserDAL.listenToUserDetails(authUser, async (data) => {
                if (!data) {
                    userDetails.set(null);
                } else {
                    // let ud = snapshot.data();
                    userDetails.set(data);
                    let loyaltyCards = await BusinessBL.listenToUserLoyaltyCards(data);

                    if (loyaltyCards) {

                        //filter retired
                        if (!isObjectEmpty(loyaltyCards)) {
                            let filtered = {};

                            Object.keys(loyaltyCards).forEach(cardId => {
                                if (!loyaltyCards[cardId].retired) {
                                    filtered[cardId] = loyaltyCards[cardId];
                                }
                            })
                            loyaltyCards = filtered;
                        }

                        userDetails.update(u => {
                            u.loyaltyCards = loyaltyCards;
                            return u;
                        })
                    }
                }
            });
    } catch (e) {
        showPopup("...משהו השתבש", () => { });
        UserDAL.sendLog("listen to user details", e.toString());
        console.error(e)
    }
}

